import React from "react";
import { Descriptions, Button, Tag, Space } from "antd";
import { useParams, useNavigate } from "react-router-dom";

const ReportView = () => {
  const { reportId } = useParams();
  const navigate = useNavigate();

  // Sample data (replace with API or Redux in a real app)
  const data = [
    {
      key: "1",
      id: "R001",
      content: "Nội dung vi phạm quy tắc cộng đồng.",
      date: "2025-02-17",
      sender: "Nguyễn Văn A",
      appliedTo: "Bài viết #123",
      reportType: "Ngôn từ thù địch",
      status: "Đã xử lý",
    },
    {
      key: "2",
      id: "R002",
      content: "Spam quảng cáo không phù hợp.",
      date: "2025-02-16",
      sender: "Trần Thị B",
      appliedTo: "Bình luận #456",
      reportType: "Spam",
      status: "Đang xem xét",
    },
    {
      key: "3",
      id: "R003",
      content: "Hình ảnh không phù hợp.",
      date: "2025-02-15",
      sender: "Lê Văn C",
      appliedTo: "Bài viết #789",
      reportType: "Nội dung nhạy cảm",
      status: "Đã xử lý",
    },
  ];

  const report = data.find((item) => item.id === reportId) || {};

  return (
    <div style={{ padding: "20px", backgroundColor: "#f0f2f5" }}>
      {/* Header */}
      <h2 style={{ marginBottom: "20px", fontWeight: "bold" }}>
        Chi tiết báo cáo
      </h2>

      {/* Report Details */}
      <Descriptions
        bordered
        column={1} // Single column for better readability
        style={{ marginBottom: "20px" }}
      >
        <Descriptions.Item label="ID">
          {report.id || "Không có"}
        </Descriptions.Item>
        <Descriptions.Item label="Nội dung">
          {report.content || "Không có"}
        </Descriptions.Item>
        <Descriptions.Item label="Ngày gửi">
          {report.date || "Không có"}
        </Descriptions.Item>
        <Descriptions.Item label="Người gửi">
          {report.sender || "Không có"}
        </Descriptions.Item>
        <Descriptions.Item label="Áp dụng với">
          {report.appliedTo || "Không có"}
        </Descriptions.Item>
        <Descriptions.Item label="Loại báo cáo">
          {report.reportType ? (
            <Tag color="blue">{report.reportType}</Tag>
          ) : (
            "Không có"
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Tình trạng">
          {report.status ? (
            <Tag color={report.status === "Đã xử lý" ? "green" : "volcano"}>
              {report.status}
            </Tag>
          ) : (
            "Không có"
          )}
        </Descriptions.Item>
      </Descriptions>

      {/* Action Buttons */}
      <div style={{ marginTop: "20px", marginBottom: "20px" }}>
        <h3 style={{ marginBottom: "10px" }}>Xử lý</h3>
        <Space>
          <Button type="primary">Cảnh cáo</Button>
          <Button type="primary" danger>
            Khóa
          </Button>
          <Button type="primary" danger>
            Gỡ
          </Button>
        </Space>
      </div>

      {/* Back Button */}
      <div style={{ marginTop: "20px" }}>
        <Button onClick={() => navigate("/censor/moderations_log")}>
          Quay lại
        </Button>
      </div>
    </div>
  );
};

export default ReportView;
